export default "__VITE_ASSET__CO4_jpcD__"